import gql from "graphql-tag";

export const SAVE_MEASURMENTS_MUTATION = gql`
  mutation saveMeasurements($productId: ID!, $reportId: ID!, $sheetId: ID!, $measurements: [SaveMeasurementsInput!]!) {
    saveMeasurements(productId: $productId, reportId: $reportId, sheetId: $sheetId, measurements: $measurements)
  }
`;
